import { useCallback } from 'react';
import useSWR from 'swr';
import { useDispatch } from 'react-redux';
import { api } from 'Utils';
import {
	getMarkersRequest,
	setFilterMarkers,
	setOriginMarkers,
	getMarkersFail
} from 'Actions';

export const useStory = () => {
	const { data, error } = useSWR(api.getMarkers);
	const dispatch = useDispatch();

	const initStories = useCallback(() => {
		dispatch(getMarkersRequest());
		if (data) {
			dispatch(setFilterMarkers(data.list));
			dispatch(setOriginMarkers(data.list));
		}
		if (error) {
			dispatch(getMarkersFail());
		}
	}, [data, error, dispatch]);

	return { initStories };
};
